import * as React from 'react';
import { useState, useEffect } from 'react';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import {DateUtil} from "../../fxms/datas/DateUtil";

/* 공장대시보드 실시간 전력 사용현황 */
export const FxDashChart3 = (props) => {
    const { energy, dataToday, dataBefor, showPeakPower = true} = props;

    //console.log("*** FxDashChart3 ***", energy, "dataToday", dataToday, "dataBefor" , dataBefor);
    
    const getData = (values) => {
        let data = [];       
        if ( Object.keys(dataToday).length != 0 && Object.keys(dataBefor).length != 0) {                    
            if(values !== undefined) {
                for (const value of values ) {                                  
                    data.push([DateUtil.makeDate(value.psDate).getTime(), value.consAmt]);              
                }
            }             
        }
        return data;
    }

    const getPeakData = (values) => {
        let data = [];       
        if ( Object.keys(dataToday).length != 0 && Object.keys(dataBefor).length != 0) {                    
            if(values !== undefined) {
                for (const value of values) {                                    
                    data.push([DateUtil.makeDate(value.psDate).getTime(), Number(value.limitVal)]);              
                }
                for (const value of dataBefor ) { 
                    if(values.filter(i=> i.psDate === value.psDate).length === 0){
                        data.push([DateUtil.makeDate(value.psDate).getTime(), Number(value.limitVal)]);    
                    }
                }
            }
            
            
        }
        return data;
    }

     const getChartData = (title) => {
        // 기본 series 배열 생성
        const basicSeries = [];

        // showPeakPower가 true일 때만 피크전력 series 추가
        if (showPeakPower) {
            basicSeries.push({
                name: '피크전력',
                type: 'line',
                data: getPeakData(dataToday), 
                tooltip: {
                    valueSuffix: 'kw'
                },
                marker: {
                    enabled: false, 
                }                  
            },
            {
                name: '전일',
                type: 'column',
                data: getData(dataBefor),
                tooltip: {
                    valueSuffix: 'kw'
                },                    
            },
            {
                name: '당일',
                type: 'column',
                data: getData(dataToday), 
                tooltip: {
                    valueSuffix: 'kw'
                },                  
            });
        }

        return {
            title: {
                text: title,
                align: "center",
            },
        
            tooltip: {
                formatter: function () {
                    let tooltip  = new Date(this.points[0].x).toLocaleTimeString('ko-KR', {hour: "numeric", hour12: false, minute: "numeric"})+'<br>';
                    for(var i in this.points){
                        tooltip += this.points[i].series.name+ ': '  + this.points[i].y +' kw<br>';
                    }

                    return tooltip;
                },
                shared: true               
            },
            plotOptions: {
                series: {                    
                    animation: false,
                    cursor: 'pointer',
                   
                },
                column: {
                    //pointPadding: 0.1,                   
                    borderWidth: 1
                }
            },
            series: basicSeries,
            xAxis: {
                type: "datetime",             
                labels: {
                  style: {
                    color: "rgba(255,255,255,0.8)"
                  },
                  formatter: function() {                  
                    return  new Date(this.value).toLocaleTimeString('ko-KR', {hour: "numeric", hour12: false});
                    }
                },    
            },
            yAxis: {
                 title: {
                    text: null,
                },
                lineWidth: 1,
                lineColor: '#3e3e3e',
                gridLineColor: '#3e3e3e'
            },    
            chart: {
                backgroundColor: "#313131",
                borderWidth: 1,
                borderRadius: 0,
                borderColor: "#303030",
                plotBackgroundColor: "#303030",
                plotBorderWidth: 1,
                plotBorderColor: "#303030"
            }           
            ,
            legend: {
                align: 'left',
                x: 60,
                verticalAlign: 'top',
                y: 1,
                floating: true,               
                backgroundColor:'grey'
            }
        };
    }


     useEffect(() => {
        const values1 = dataToday;
        const values2 = dataBefor;
        if (values1 === undefined || values2 === undefined ) {
            return;
        }
    }, [dataToday, dataBefor, energy])


    return (    
        <HighchartsReact
            containerProps={{ style: { height: "210px",width:"100%" } }}
            highcharts={Highcharts}
            options={getChartData('', '', '', '')}
        />       
    );
}